import http from './httpClient';

// API методы для управления меню
class MenuApiService {
  // Получение списка блюд с фильтрацией и пагинацией
  async getAdminDishes(params = {}) {
    try {
      const response = await http.get('/api/menu/admin/dishes/', { params });
      return response.data;
    } catch (error) {
      console.error('Ошибка получения блюд:', error);
      throw new Error(error.response?.data?.error || 'Ошибка получения блюд');
    }
  }

  // Получение деталей блюда
  async getDishDetails(dishId) {
    try {
      const response = await http.get(`/api/menu/admin/dishes/${dishId}/`);
      return response.data;
    } catch (error) {
      console.error('Ошибка получения деталей блюда:', error);
      throw new Error(error.response?.data?.error || 'Ошибка получения деталей блюда');
    }
  }

  // Создание нового блюда
  async createDish(dishData) {
    try {
      // Если есть изображение, используем FormData
      let data = dishData;
      let headers = {};
      
      if (dishData.image instanceof File) {
        data = new FormData();
        Object.keys(dishData).forEach(key => {
          if (dishData[key] !== null && dishData[key] !== undefined) {
            data.append(key, dishData[key]);
          }
        });
        headers['Content-Type'] = 'multipart/form-data';
      }

      const response = await http.post('/api/menu/admin/dishes/', data, { headers });
      return response.data;
    } catch (error) {
      console.error('Ошибка создания блюда:', error);
      throw new Error(error.response?.data?.error || 'Ошибка создания блюда');
    }
  }

  // Обновление блюда
  async updateDish(dishId, dishData) {
    try {
      // Если есть изображение, используем FormData
      let data = dishData;
      let headers = {};
      
      if (dishData.image instanceof File) {
        data = new FormData();
        Object.keys(dishData).forEach(key => {
          if (dishData[key] !== null && dishData[key] !== undefined) {
            data.append(key, dishData[key]);
          }
        });
        headers['Content-Type'] = 'multipart/form-data';
      }

      const response = await http.patch(`/api/menu/admin/dishes/${dishId}/`, data, { headers });
      return response.data;
    } catch (error) {
      console.error('Ошибка обновления блюда:', error);
      throw new Error(error.response?.data?.error || 'Ошибка обновления блюда');
    }
  }

  // Удаление блюда
  async deleteDish(dishId) {
    try {
      const response = await http.delete(`/api/menu/admin/dishes/${dishId}/`);
      return response.data;
    } catch (error) {
      console.error('Ошибка удаления блюда:', error);
      throw new Error(error.response?.data?.error || 'Ошибка удаления блюда');
    }
  }

  // Получение списка категорий
  async getAdminCategories(establishmentId = null) {
    try {
      const params = establishmentId ? { establishment: establishmentId } : {};
      const response = await http.get('/api/menu/admin/categories/', { params });
      return response.data;
    } catch (error) {
      console.error('Ошибка получения категорий:', error);
      throw new Error(error.response?.data?.error || 'Ошибка получения категорий');
    }
  }

  // Получение деталей категории
  async getCategoryDetails(categoryId) {
    try {
      const response = await http.get(`/api/menu/admin/categories/${categoryId}/`);
      return response.data;
    } catch (error) {
      console.error('Ошибка получения деталей категории:', error);
      throw new Error(error.response?.data?.error || 'Ошибка получения деталей категории');
    }
  }

  // Создание новой категории
  async createCategory(categoryData) {
    try {
      // Если есть изображение, используем FormData
      let data = categoryData;
      let headers = {};
      
      if (categoryData.image instanceof File) {
        data = new FormData();
        Object.keys(categoryData).forEach(key => {
          if (categoryData[key] !== null && categoryData[key] !== undefined) {
            data.append(key, categoryData[key]);
          }
        });
        headers['Content-Type'] = 'multipart/form-data';
      }

      const response = await http.post('/api/menu/admin/categories/', data, { headers });
      return response.data;
    } catch (error) {
      console.error('Ошибка создания категории:', error);
      throw new Error(error.response?.data?.error || 'Ошибка создания категории');
    }
  }

  // Обновление категории
  async updateCategory(categoryId, categoryData) {
    try {
      // Если есть изображение, используем FormData
      let data = categoryData;
      let headers = {};
      
      if (categoryData.image instanceof File) {
        data = new FormData();
        Object.keys(categoryData).forEach(key => {
          if (categoryData[key] !== null && categoryData[key] !== undefined) {
            data.append(key, categoryData[key]);
          }
        });
        headers['Content-Type'] = 'multipart/form-data';
      }

      const response = await http.patch(`/api/menu/admin/categories/${categoryId}/`, data, { headers });
      return response.data;
    } catch (error) {
      console.error('Ошибка обновления категории:', error);
      throw new Error(error.response?.data?.error || 'Ошибка обновления категории');
    }
  }

  // Удаление категории
  async deleteCategory(categoryId) {
    try {
      const response = await http.delete(`/api/menu/admin/categories/${categoryId}/`);
      return response.data;
    } catch (error) {
      console.error('Ошибка удаления категории:', error);
      throw new Error(error.response?.data?.error || 'Ошибка удаления категории');
    }
  }

  // Получение статистики меню
  async getMenuStats(establishmentId = null) {
    try {
      const params = establishmentId ? { establishment: establishmentId } : {};
      const response = await http.get('/api/menu/admin/stats/', { params });
      return response.data;
    } catch (error) {
      console.error('Ошибка получения статистики меню:', error);
      throw new Error(error.response?.data?.error || 'Ошибка получения статистики меню');
    }
  }

  // Получение списка заведений (для выбора при создании категории)
  async getEstablishments() {
    try {
      const response = await http.get('/api/establishments/list/');
      return response.data;
    } catch (error) {
      console.error('Ошибка получения заведений:', error);
      throw new Error(error.response?.data?.error || 'Ошибка получения заведений');
    }
  }
}

// Создаем экземпляр сервиса
const menuApiService = new MenuApiService();

export default menuApiService; 